import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useForm } from "@mantine/form";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { Button, Checkbox, Grid, PhoneInput } from "..";
import { Input } from "./input";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var DonationCard = props => {
  var _router$query, _router$query2;

  var {
    identifier,
    regular_giving,
    prices = [50, 100, 250, 500],
    thank_you
  } = props;
  var router = useRouter();
  var form = useForm({
    initialValues: {
      is_organisation: false,
      organisation: "",
      first_name: "",
      last_name: "",
      email: "",
      phone: "61",
      unit_amount: "50",
      type: "once",
      cover_fee: true // auth_required: false,
      // verification_code: "",

    },
    validate: {
      email: value => /^\S+@\S+$/.test(value) ? null : "This must be a valid email.",
      unit_amount: value => /^\d*$/.test(value) ? null : "This must be a valid whole number.",
      phone: value => /^\d+$/.test(value) ? null : "This field is required." // verification_code: (value, values) =>
      //   values?.auth_required ? /^\d+$/.test(value) : true,
      //   "We've detected an existing account under your email. Please type the code sent to your email to verify your email.",

    }
  });
  useEffect(() => {
    if (form.values.type === "once") {
      if (parseInt(form.values.unit_amount || "2") < 2) {
        form.setFieldError("unit_amount", "Value must be $2 or greater");
      }
    } else {
      if (parseInt(form.values.unit_amount || "20") < 20) {
        form.setFieldError("unit_amount", "Value must be $20 or greater");
      }
    }
  }, [form.values.type, form.values.unit_amount]);
  var product = String((router == null ? void 0 : (_router$query = router.query) == null ? void 0 : _router$query.product) || "") || identifier;
  var rg_product = String((router == null ? void 0 : (_router$query2 = router.query) == null ? void 0 : _router$query2.rg_product) || "") || regular_giving;
  var extra_fee = (parseInt(form.values.unit_amount) * 0.029 + 0.3).toFixed(2); // useEffect(() => {
  //   form.validateField("verification_code");
  // }, [form.values.auth_required]);

  useEffect(() => {
    sessionStorage.setItem("form_values", JSON.stringify(form.values));
  }, [...Object.values(form.values)]);
  useEffect(() => {
    var values = sessionStorage.getItem("form_values");
    if (values) form.setValues(JSON.parse(values));
  }, []); // const verify = () => {
  //   if (form.errors.email || !form.values.email || form.values.auth_required)
  //     return;
  //   fetch(`/api/donate/active`, {
  //     headers: new Headers({
  //       "Content-Type": "application/json",
  //       Accept: "application/json",
  //     }),
  //     method: "POST",
  //     body: JSON.stringify({
  //       email: form.values.email,
  //     }),
  //   })
  //     .then((res) => res.json())
  //     .then(({ active }: { active: boolean }) => {
  //       form.setFieldValue("auth_required", active);
  //     });
  // };

  return /*#__PURE__*/_jsxs("form", {
    id: "donate",
    className: "bg-grey-100/10 rounded-container shadow-lg p-8",
    autoComplete: "on",
    onSubmit: form.onSubmit( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (values) {
        fetch("/api/donate", {
          headers: new Headers({
            "Content-Type": "application/json",
            Accept: "application/json"
          }),
          method: "POST",
          body: JSON.stringify(_extends({}, values, {
            type: values.type.replaceAll("ly", ""),
            product: values.type === "once" ? product : rg_product,
            success_url: thank_you || router.asPath,
            cancel_url: router.asPath
          }))
        }).then(res => res.json()).then(_ref2 => {
          var {
            url
          } = _ref2;
          if (url) return window.location = url; // if (error_description) {
          //   form.setFieldError("verification_code", error_description);
          //   if (!form.values.auth_required)
          //     form.setFieldValue("auth_required", true);
          // }
        });
      });

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()),
    children: [/*#__PURE__*/_jsx("h3", {
      children: "Donate Now"
    }), /*#__PURE__*/_jsxs(Grid, {
      gap: "4",
      children: [/*#__PURE__*/_jsx(Checkbox, _extends({}, form.getInputProps("is_organisation", {
        type: "checkbox"
      }), {
        children: "I'm donating as an organisation"
      })), form.values.is_organisation && /*#__PURE__*/_jsx(Input, _extends({
        id: "organisation",
        required: true,
        placeholder: "Organisation Name",
        autoComplete: "organization"
      }, form.getInputProps("organisation"), {
        children: "Organisation Name"
      })), /*#__PURE__*/_jsxs(Grid, {
        layout: "1-1",
        gap: "4",
        children: [/*#__PURE__*/_jsx(Input, _extends({
          id: "first_name",
          required: true,
          placeholder: "First Name",
          autoComplete: "given-name"
        }, form.getInputProps("first_name"), {
          children: "First Name"
        })), /*#__PURE__*/_jsx(Input, _extends({
          id: "last_name",
          required: true,
          placeholder: "Last Name",
          autoComplete: "family-name"
        }, form.getInputProps("last_name"), {
          children: "Last Name"
        }))]
      }), /*#__PURE__*/_jsx(Input, _extends({
        id: "email",
        required: true,
        type: "email",
        autoComplete: "email",
        placeholder: "Email" // disabled={!!user}
        // onBlur={() => verify()}

      }, form.getInputProps("email"), {
        children: "Email"
      })), /*#__PURE__*/_jsx(PhoneInput, _extends({
        isValid: (inputNumber, country, countries) => {
          var _country$iso;

          var ok = countries.some(country => {
            try {
              return new RegExp(country.format.replaceAll("+", "").replaceAll(" ", "").replaceAll("(", "\\(").replaceAll(")", "\\)").replaceAll("-", "\\-")).test(inputNumber);
            } catch (error) {
              return true;
            }
          });
          if (!ok && !form.errors.phone && form.values.email) form.setFieldError("phone", "Must be a valid " + (country == null ? void 0 : (_country$iso = country.iso2) == null ? void 0 : _country$iso.toUpperCase()) + " phone number.");
          return ok;
        }
      }, form.getInputProps("phone"), {
        children: "Phone Number"
      })), rg_product && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          className: "mt-2 m-0",
          children: /*#__PURE__*/_jsx("strong", {
            children: "How often do you wish to donate?"
          })
        }), /*#__PURE__*/_jsx(Grid, {
          layout: "1-1-1",
          gap: "4",
          children: ["once", "weekly", "monthly"].map((type, i) => {
            var selected = String(type) === form.values.type;
            return /*#__PURE__*/_jsx(Button, {
              type: "button",
              color: selected ? "secondary" : "primary",
              disabled: selected,
              size: "md",
              onClick: () => {
                form.setFieldValue("type", String(type));
              },
              children: capitalise(type)
            }, i);
          })
        })]
      }), /*#__PURE__*/_jsx("p", {
        className: "mt-2 m-0",
        children: /*#__PURE__*/_jsx("strong", {
          children: "Please select a donation amount"
        })
      }), /*#__PURE__*/_jsx(Grid, {
        layout: "1-1-1-1",
        gap: "4",
        children: prices.map((unit_amount, i) => {
          var selected = String(unit_amount) === form.values.unit_amount;
          return /*#__PURE__*/_jsxs(Button, {
            type: "button",
            color: selected ? "secondary" : "primary",
            disabled: selected,
            size: "lg",
            onClick: () => {
              form.setFieldValue("unit_amount", String(unit_amount));
            },
            children: ["$", unit_amount]
          }, i);
        })
      }), /*#__PURE__*/_jsx(Input, _extends({
        id: "custom_amount",
        type: "number",
        prefix: "$",
        placeholder: "50"
      }, form.getInputProps("unit_amount"), {
        children: "Or enter a custom amount"
      })), /*#__PURE__*/_jsx(Checkbox, _extends({}, form.getInputProps("cover_fee", {
        type: "checkbox"
      }), {
        children: /*#__PURE__*/_jsxs("small", {
          children: ["I'd like to cover the transaction fee.", " ", form.values.cover_fee ? "This will add an extra ($" + extra_fee + ")" : ""]
        })
      })), /*#__PURE__*/_jsxs("small", {
        children: ["By donating online you are agreeing to the terms in", " ", /*#__PURE__*/_jsx("a", {
          className: "underline",
          href: "https://cancerqld.org.au/about-us/our-privacy-policy/fundraising-privacy-collection-statement/",
          target: "_blank",
          children: "Cancer Council Queensland\u2019s Privacy Collection Statement."
        })]
      }), /*#__PURE__*/_jsx(Button, {
        color: "primary",
        size: "lg",
        width: "fit-content",
        type: "submit",
        role: "link",
        children: "Donate"
      })]
    })]
  });
};

var capitalise = str => str.charAt(0).toUpperCase() + str.slice(1);
//# sourceMappingURL=donation_card.js.map